module.exports = __webpack_public_path__ + "img/Miladnieuw.c2b853c0.jpg";